import { useEffect, useState } from 'preact/hooks';
import type { IncomingReaction } from '../lib/reactions.js';
import { REACTIONS } from '../lib/reactions.js';

interface Floating extends IncomingReaction {
  key: number;
  /** Horizontal offset so simultaneous reactions do not stack in one column. */
  x: number;
  drift: number;
}

const GLYPH = new Map(REACTIONS.map((r) => [r.id, r.glyph]));
const LIFETIME_MS = 2600;
/* A packed room can emit hundreds a second. Past a couple of dozen on screen
   nobody can tell the difference, and the animation starts costing frames on
   exactly the cheap phones this product targets. */
const MAX_ON_SCREEN = 24;

export function ReactionLayer({ feed }: { feed: IncomingReaction[] }) {
  const [floating, setFloating] = useState<Floating[]>([]);

  useEffect(() => {
    const latest = feed.at(-1);
    if (!latest) return;
    const item: Floating = {
      ...latest,
      key: Date.now() + Math.random(),
      x: 8 + Math.random() * 68,
      drift: -20 + Math.random() * 40,
    };
    setFloating((current) => [...current, item].slice(-MAX_ON_SCREEN));
    const timer = setTimeout(
      () => setFloating((current) => current.filter((f) => f.key !== item.key)),
      LIFETIME_MS,
    );
    return () => clearTimeout(timer);
  }, [feed]);

  return (
    <div class="reactions" aria-hidden="true">
      {floating.map((item) => (
        <span
          key={item.key}
          class="reactions__item"
          style={{ left: `${item.x}%`, '--drift': `${item.drift}px` }}
        >
          {GLYPH.get(item.id)}
        </span>
      ))}
    </div>
  );
}
